import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type FlowLineProps = {
  steps: string[];
  label?: string;
  className?: string;
  tone?: 'light' | 'dark';
};
export function FlowLine({
  steps,
  label,
  className = '',
  tone = 'light'
}: FlowLineProps) {
  const dark = tone === 'dark';
  return <div className={className} data-id="element-149" data-mp="3vx2g91gu05fc">
      {label && <p className={`mb-3 text-xs font-bold uppercase tracking-[0.14em] ${dark ? 'text-accent-soft' : 'text-primary'}`} data-id="element-150" data-mp="3vzovln9yrp84">
          {label}
        </p>}
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-2" aria-label={steps.join(', ')} data-id="element-151" data-mp="33ahlrs527d7k">
        {steps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-152" data-mp="3c93c49grvwiw" data-mpi={index}>
            <span className={`rounded-md border px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.08em] ${dark ? 'border-accent/40 bg-inverse-foreground/5 text-accent-soft' : 'border-accent/40 bg-muted/60 text-foreground'}`} data-id="element-153" data-mp="3cbphc2g6xzxy">
              {step}
            </span>
            {index < steps.length - 1 && <ArrowRightIcon size={14} className="shrink-0 text-accent" aria-hidden="true" data-id="element-154" data-mp="1om09uhwvn66l" />}
          </li>)}
      </ol>
    </div>;
}